declare var removeItemPath: string;
declare var waveOrderMode: number | null;
declare var isViewOnly: boolean;

class WaveItemCheckboxManager {
    private selectAllCheckbox: JQuery<HTMLElement>;
    private itemCheckboxes: JQuery<HTMLElement>;
    private bulkDeleteBtn: JQuery<HTMLElement>;

    constructor() {
        this.selectAllCheckbox = $('#select_all_wave_items');
        this.itemCheckboxes = $('.wave-item-checkbox');
        this.bulkDeleteBtn = $('#bulk-delete-items-btn');
        this.bindEvents();
        this.updateBulkDeleteButton();
    }

    private bindEvents(): void {
        // Select all functionality - only affects enabled checkboxes
        this.selectAllCheckbox.on('change', () => {
            const isChecked = this.selectAllCheckbox.is(':checked');
            $('.wave-item-checkbox:not(:disabled)').prop('checked', isChecked);
            this.updateBulkDeleteButton();
        });

        // Update select all checkbox and bulk delete button when individual checkboxes change
        $(document).on('change', '.wave-item-checkbox:not(:disabled)', () => {
            this.updateSelectAllState();
            this.updateBulkDeleteButton();
        });

        // Handle bulk delete button click
        this.bulkDeleteBtn.on('click', () => {
            this.handleBulkDelete();
        });
    }

    private updateSelectAllState(): void {
        // Only consider enabled checkboxes
        const enabledCheckboxes = $('.wave-item-checkbox:not(:disabled)');
        const totalEnabled = enabledCheckboxes.length;
        const checkedEnabled = enabledCheckboxes.filter(':checked').length;
        this.selectAllCheckbox.prop('checked', totalEnabled === checkedEnabled && totalEnabled > 0);
    }

    private updateBulkDeleteButton(): void {
        const selectedIds = this.getSelectedItemIds();
        // Disable button if view_only mode or no items selected
        if (selectedIds.length > 0 && !isViewOnly) {
            this.bulkDeleteBtn.removeClass('disabled').prop('disabled', false);
        } else {
            this.bulkDeleteBtn.addClass('disabled').prop('disabled', true);
        }
    }

    private handleBulkDelete(): void {
        const selectedIds = this.getSelectedItemIds();
        
        if (selectedIds.length === 0) {
            return;
        }

        // Show the remove modal in bulk mode
        if ((window as any).WOPPickingShow && typeof (window as any).WOPPickingShow.showBulkDeleteModal === 'function') {
            (window as any).WOPPickingShow.showBulkDeleteModal(selectedIds);
        }
    }

    public getSelectedItemIds(): number[] {
        // Only return IDs from enabled and checked checkboxes
        return $('.wave-item-checkbox:not(:disabled):checked').map(function() {
            return parseInt($(this).val() as string, 10);
        }).get();
    }

    public refresh(): void {
        this.itemCheckboxes = $('.wave-item-checkbox');
        this.updateSelectAllState();
        this.updateBulkDeleteButton();
    }
}

export default WaveItemCheckboxManager;

